import { useState, useEffect } from 'react';
import { getDiscountCodeAffiliatePerformance } from '../services/affiliateService';

export interface DiscountCodePerformance {
  discountCodeId: string;
  commissionCount: number;
  totalEarnings: number;
  totalOrderValue: number;
  uniqueAffiliates: number;
  avgOrderValue: number;
  avgCommission: number;
}

export const useDiscountCodePerformance = (timePeriod?: string) => {
  const [performance, setPerformance] = useState<DiscountCodePerformance[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPerformance = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getDiscountCodeAffiliatePerformance(timePeriod);
      setPerformance(data);
    } catch (err) {
      console.error('Error fetching discount code performance:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch performance data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPerformance();
  }, [timePeriod]);

  return {
    performance,
    loading,
    error,
    refresh: fetchPerformance
  };
}; 